<app-navbar></app-navbar>

<div class="flex-grow min-h-0 flex flex-col">
  <router-outlet></router-outlet>
</div>

<router-outlet name="modal"></router-outlet>
